import e from "react";
import { t } from "../../../i18/index.js";
import { componentName as o } from "../../../utils/bem/index.js";
import { Button as r } from "../../buttons/Button/Button.js";
import { KASEYA as a } from "../../../constants/kaseya.js";
function n(n) {
  var s,
    i,
    p = n.isK1LoginEnabled,
    l = n.hasAdminPermissions,
    m = n.onK1LoginEnable,
    b = l || p,
    u = l ? ["admin-login", t("topbar.enable-login-with-k1-description")] : p ? ["user-login", t("topbar.sso-enabled")] : ["not-allowed", t("topbar.sso-no-access")];
  return e.createElement("div", {
    className: o("sso-popup")
  }, e.createElement("p", {
    className: o("menu-header-text", "sso-popup__title")
  }, t("topbar.sso-title")), b && e.createElement(r, {
    variant: "primary",
    label: t(l ? "topbar.enable-login-with-k1" : "topbar.login-with-k1"),
    autoWidth: !0,
    onClick: m
  }), e.createElement("p", {
    className: o("support-text", "sso-popup__support-text", (s = {}, (i = u[0]) in s ? Object.defineProperty(s, i, {
      value: !0,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : s[i] = !0, s))
  }, u[1]), e.createElement("a", {
    className: o("button-text", "sso-popup__link"),
    target: "_blank",
    rel: "noopener noreferrer",
    href: a.SSO_LEARN_MORE_URL
  }, t("topbar.learn-more")));
}
export { n as SsoPopup };